/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./components/WizardImportPersonalData'));
